import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const get = async (url, params, fallback) => {
    try {
        const r = await axios.get(`${API_BASE_URL}${url}`, { params });
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

const post = async (url, payload, fallback) => {
    try {
        const r = await axios.post(`${API_BASE_URL}${url}`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

const put = async (url, payload, fallback) => {
    try {
        const r = await axios.put(`${API_BASE_URL}${url}`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

// ── Lookups ──────────────────────────────────────────────────────────────────

export const getNatureOfGroups = () => get('/Accounts/GetNatureofGroups', {}, 'Failed to fetch nature of groups');
export const getMasterGroupsByNature = (NatureGroupId) =>
    get('/Accounts/GetMasterGroupbsbyNature', { NatureGroupId }, 'Failed to fetch groups');
export const getSubGroupsByGroupId = (GroupId) =>
    get('/Accounts/GetAllSubGroupsbyGroupid', { GroupId }, 'Failed to fetch sub groups');
export const getApprovalStatusClient = (ROID) =>
    get('/Accounts/GetStatuslistother', { CheckType: 'Client', ROID, CCCode: '' }, 'Failed to fetch allowed actions');
export const getApprovalStatusSubClient = (ROID) =>
    get('/Accounts/GetStatuslistother', { CheckType: 'SubClient', ROID, CCCode: '' }, 'Failed to fetch allowed actions');
export const getStatesList = () => get('/Accounts/GetStatesList', {}, 'Failed to fetch states');
export const getAllLedgerDetails = () => get('/Accounts/GetAllLedgerDetails', {}, 'Failed to fetch ledgers');

// ── Grid / Edit ──────────────────────────────────────────────────────────────

export const getAllClientDetails = () => get('/Accounts/GetAllClientDetails', {}, 'Failed to fetch clients');
export const getClientDetailsByCode = (clientcode) =>
    get('/Accounts/GetClientDetailsbyCode', { clientcode }, 'Failed to fetch client details');
export const getTaxesForClient = (clientcode) =>
    get('/Accounts/GetTaxesForClient', { clientcode }, 'Failed to fetch GST details');

// ── Save / Edit ──────────────────────────────────────────────────────────────

export const saveNewClient = (payload) => post('/Accounts/SaveNewClient', payload, 'Failed to save client');
export const updateClient = (payload) => put('/Accounts/UpdateClient', payload, 'Failed to update client');

// ── Sub Client ───────────────────────────────────────────────────────────────

export const checkSubClientEligibility = (ClientCode, Roelid) =>
    get('/Accounts/CheckSubClientbyClientCodebyRoleid', { ClientCode, Roelid }, 'Failed to check sub client eligibility');
export const getSubClientsByClientCode = (ClientCode) =>
    get('/Accounts/GetSubClientbyClientCode', { ClientCode }, 'Failed to fetch sub clients');
export const getSubClientDetails = (ClientCode, Subclient) =>
    get('/Accounts/GetSubClientDtails', { ClientCode, Subclient }, 'Failed to fetch sub client details');
export const saveNewSubClient = (payload) => post('/Accounts/SaveNewSubClient', payload, 'Failed to save sub client');
export const updateSubClientDetails = (payload) => put('/Accounts/UpdateSubClientDetails', payload, 'Failed to update sub client');
